/* ═══ טעינת מנגנון הכנת התמונה ═══
 *
 * הקובץ נטען מכאן ולא מתגית <script> בסקשן, מסיבה מעשית: הסקשן הוא
 * קובץ של 197KB, ועדכון שלו בשרת החי דורש כתיבה מחדש של כולו. טעינה
 * מכאן מצמצמת את הפריסה לשני קבצי assets בלבד — פחות שטח לטעות.
 *
 * הכתובת נגזרת מהכתובת של הקובץ הזה עצמו, ולכן היא עובדת גם מה-CDN
 * של Shopify עם ה-hash שבשם, בלי צורך ב-Liquid.
 *
 * אם הטעינה נכשלת — compressImage פשוט ממשיך במסלול הישן.
 */
(function () {
  if (window.PZImagePrep) return;
  var self = document.currentScript && document.currentScript.src;
  if (!self) return;
  var url = self.replace(/pillow-engine\.js/, 'pillow-image-prep.js');
  if (url === self) return;
  var tag = document.createElement('script');
  tag.src = url;
  tag.async = false;   // חייב לרוץ לפני ההעלאה הראשונה, לא אחריה
  tag.onerror = function () {
    console.warn('הכנת התמונה לא נטענה, ממשיכים במסלול הישן');
  };
  document.head.appendChild(tag);
})();

const mainPreviewImage = document.getElementById('mainPreviewImage');
    const glCanvas = document.getElementById('glcanvas');
    const toggleBtn = document.getElementById('toggleRotationBtn');

    const originalImg = document.getElementById('adminImageUrl1');
    const processedImg = document.getElementById('adminImageUrl2');

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isLowPower = isIOS;

    let paddingPercent = 2;
    let centervolumePercent = 0.5;
    let edgevolumePercent = centervolumePercent/6000;
    let labelRatio = 4.0; // Label width/height ratio
    // labelHeightPercent is declared in script.js
    // magnetPower is declared in script.js
    // maxSizeCm is declared in script.js
    let uploadedImageBase64 = null;
    let devModeEnabled = true;
    const loadingOverlayEl = document.getElementById('loading-overlay');
    const loadingTextEl = document.getElementById('loading-text');
    const progressContainerEl = document.getElementById('progressContainer');
    const progressFillEl = document.getElementById('progressFill');
    const statusTextEl = document.getElementById('statusText');

    // Hebrew storefront: localize user-facing strings when the page language is Hebrew
    const IS_HEBREW = (document.documentElement.lang || '').toLowerCase().startsWith('he');
    const tr = (en, he) => (IS_HEBREW ? he : en);
    const HE_COLOR_NAMES = {
      White: 'לבן',
      Black: 'שחור',
      Red: 'אדום',
      Navy: 'כחול כהה',
      Teal: 'טורקיז',
      Beige: "בז'",
      Gray: 'אפור'
    };
    const localColorName = (name) => (IS_HEBREW && HE_COLOR_NAMES[name] ? HE_COLOR_NAMES[name] : name);

    // Play Stop Toggle Button
    toggleBtn.addEventListener('click', () => {
      rotationEnabled = !rotationEnabled;

      toggleBtn.textContent = rotationEnabled
        ? tr('⏸ Stop', '⏸ עצירה')
        : tr('▶ Play', '▶ הפעלה');
    });
    
    function setLoading(isLoading, message) {
      if (!loadingOverlayEl) return;
      loadingOverlayEl.style.display = isLoading ? 'flex' : 'none';
      if (message && loadingTextEl) {
        loadingTextEl.textContent = message;
      }
    }
    
    function normalizeDataUrl(raw, mimeHint = 'image/png') {
      if (!raw) return null;
      const trimmed = (raw || '').trim();
      if (trimmed.startsWith('data:')) return trimmed;
      const signature = trimmed.slice(0, 12);
      let mime = mimeHint || 'image/png';
      if (/^\/?9j/.test(signature)) {
        mime = 'image/jpeg';
      } else if (/^iVBOR/.test(signature)) {
        mime = 'image/png';
      } else if (/^R0lGOD/.test(signature)) {
        mime = 'image/gif';
      }
      return `data:${mime};base64,${trimmed}`;
    }
    
    function clearPreviewCanvases() {
      ['originalCanvas', 'smoothedCanvas', 'finalCanvas'].forEach(id => {
        const c = document.getElementById(id);
        if (c) {
          const ctx = c.getContext('2d');
          if (ctx) ctx.clearRect(0, 0, c.width, c.height);
        }
      });
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.size-swatch, .size-swatch-he');
      if (!btn) return;

      // Ensure it's the Size option. The Shopify option is still named "Size"
      // even on the Hebrew storefront, but accept the Hebrew names too so
      // renaming it in the admin does not silently break the preview.
      const optionName = (btn.dataset.option || '').trim();
      if (['Size', 'מידה', 'גודל'].indexOf(optionName) === -1) return;

      const value = btn.dataset.value; // e.g. "S - 40 cm" or "40 ס״מ - Small"

      // The Hebrew storefront writes the unit as ס״מ, which the old cm-only
      // pattern never matched - so maxSizeCm stayed at its default and the
      // dimension labels on the 3D pillow never changed. Accept both units,
      // any quote glyph, and fall back to the first number so a renamed
      // option value can never freeze the preview again.
      const sizeMatch =
        value.match(/(\d+(?:\.\d+)?)\s*(?:cm|ס\s*["'״׳]?\s*מ)/i) ||
        value.match(/(\d+(?:\.\d+)?)/);

      if (!sizeMatch) return;

      maxSizeCm = parseFloat(sizeMatch[1]); // 40, 50, 60, 70

      console.log('Selected size:', maxSizeCm);

      // Only regenerate if image exists
      if (
        currentImageUrl ||
        (isUsingUploaded && (uploadedImageUrl || uploadedImageBase64))
      ) {
        regenerateDimensionLabels();
      }
    });
    
    // Track current generation state
    let currentImageUrl = window.bgTextureUrl;
    let selectedColor = '#ffffff';
    let currentPillowColor = selectedColor;
    let isUsingUploaded = false;
    let zoomEnabled=false
    let showLights = false;
    let allowZoom = false;


    // Handle file upload
    let uploadedImageUrl = null;
    let uploadStartTime = null;
    let timerInterval = null;

    const HISTORY_STORAGE_KEY = 'pillow_upload_history';
    const HISTORY_LIMIT = 5;
    const COLOR_PRESETS = [
      { name: 'White', value: '#ffffff' },
      { name: 'Black', value: '#3d3d3d' },
      { name: 'Red', value: '#e53935' },
      { name: 'Navy', value: '#1e3a8a' },
      { name: 'Teal', value: '#009688' },
      { name: 'Beige', value: '#d4b59e' },
      { name: 'Gray', value: '#9e9e9e' }
    ];

    function getColorName(value) {
      if (!value) return 'White';
      const match = COLOR_PRESETS.find(c => c.value.toLowerCase() === value.toLowerCase());
      return match ? localColorName(match.name) : value;
    }

    function readHistory() {
      try {
        const raw = localStorage.getItem(HISTORY_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        console.warn('History read failed', err);
        return [];
      }
    }

    function saveHistory(entries) {
      try {
        const limited = entries.slice(0, HISTORY_LIMIT);
        localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(limited));
      } catch (err) {
        console.warn('History save failed', err);
      }
    }

    function formatHistoryTime(timestamp) {
      const date = new Date(timestamp);
      return Number.isNaN(date.getTime()) ? tr('Unknown time', 'זמן לא ידוע') : date.toLocaleString();
    }

    function renderHistory() {
      const listEl = document.getElementById('historyList');
      if (!listEl) return;
      const history = readHistory();
      listEl.innerHTML = '';

      if (!history.length) {
        listEl.innerHTML = `<div class="history-empty">${tr('No uploads yet', 'עדיין אין העלאות')}</div>`;
        return;
      }

      history.slice(0, HISTORY_LIMIT).forEach(entry => {
        const item = document.createElement('div');
        item.className = 'history-item';
        item.title = tr('Click to reload this upload', 'לחצו לטעינה מחדש של ההעלאה הזו');

        const img = document.createElement('img');
        img.className = 'history-thumb';
        img.src = entry.src;
        img.alt = tr('Previous upload', 'העלאה קודמת');
        img.loading = 'lazy';

        const colorDot = document.createElement('div');
        colorDot.className = 'history-color-dot';
        colorDot.style.background = entry.color || '#ffffff';

        const meta = document.createElement('div');
        meta.className = 'history-meta';

        const label = document.createElement('div');
        label.textContent = tr('Uploaded image', 'תמונה שהועלתה');

        const time = document.createElement('div');
        time.className = 'history-time';
        time.textContent = formatHistoryTime(entry.time);

        const colorText = document.createElement('div');
        colorText.className = 'history-color-text';
        colorText.textContent = `${tr('Color', 'צבע')}: ${getColorName(entry.color || '#ffffff')}`;

        meta.appendChild(label);
        meta.appendChild(time);
        meta.appendChild(colorText);
        item.appendChild(img);
        item.appendChild(colorDot);
        item.appendChild(meta);
        item.addEventListener('click', () => loadHistoryEntry(entry));
        listEl.appendChild(item);
      });
    }

    // function addHistoryEntry(src, color = selectedColor) {
    //   if (!src) return;
    //   const history = readHistory();
    //   const existing = history.find(entry => entry.src === src);
    //   const filtered = history.filter(entry => entry.src !== src);
    //   const entry = {
    //     src,
    //     time: existing ? existing.time : Date.now(),
    //     color,
    //     colorName: getColorName(color)
    //   };
    //   const updated = [entry, ...filtered].slice(0, HISTORY_LIMIT);
    //   saveHistory(updated);
    //   renderHistory();
    // }

    function addHistoryEntry(originalUrl, processedUrl, src, color = selectedColor) {
      if (!src) return;

      const history = readHistory();

      // Remove duplicate (same src)
      const filtered = history.filter(entry => entry.src !== src);

      const entry = {
        src: isIOS ? processedUrl : src,                // base64 preferred (for fast reload)
        originalUrl,        // API original_url
        processedUrl,       // API url
        color,
        time: Date.now()
      };

      const updated = [entry, ...filtered].slice(0, HISTORY_LIMIT);
      saveHistory(updated);
      renderHistory();
    }
    
    function loadHistoryEntry(entry) {
      if (!entry || !entry.src) return;
      const color = entry.color || '#ffffff';
      setSelectedColor(color);
      uploadedImageBase64 = entry.src;
      uploadedImageUrl = null;
      isUsingUploaded = true;
      currentPillowColor = color;

      if (originalImg) originalImg.src = entry.originalUrl;
      if (processedImg) processedImg.src = entry.processedUrl;

      document.getElementById('progressContainer').style.display = 'none';
      toggleBtn.style.display = "block";
      generate3D(entry.src, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, color, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
      addHistoryEntry(entry.src, color);
      // refreshCurrentWithColor();
    }

    function setSelectedColor(color) {
      selectedColor = color;
      currentPillowColor = color;
      updateSwatchSelection();
    }

    function updateSwatchSelection() {
      const swatches = document.querySelectorAll('.color-swatch');
      swatches.forEach(swatch => {
        const val = swatch.getAttribute('data-color') || '';
        swatch.classList.toggle('selected', val.toLowerCase() === (selectedColor || '').toLowerCase());
      });
    }

    function renderColorSwatches() {
      const container = document.getElementById('colorSwatches');
      if (!container) return;
      container.innerHTML = '';
      COLOR_PRESETS.forEach(({ name, value }) => {
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'color-swatch';
        swatch.setAttribute('data-color', value);
        swatch.title = localColorName(name);

        const fill = document.createElement('span');
        fill.className = 'color-swatch-fill';
        fill.style.setProperty('--swatch-color', value);

        swatch.appendChild(fill);

        swatch.addEventListener('click', () => {
          setSelectedColor(value);
          refreshCurrentWithColor();
          const src = isUsingUploaded ? (uploadedImageBase64 || uploadedImageUrl) : currentImageUrl;
          if (src) {
            addHistoryEntry(src, selectedColor);
          }
        });

        container.appendChild(swatch);
      });
      updateSwatchSelection();
    }

    function refreshCurrentWithColor() {
      const source = isUsingUploaded ? (uploadedImageBase64 || uploadedImageUrl) : currentImageUrl;
      if (!source) return;
      const fastUpdated = (typeof window !== 'undefined' && typeof window.updatePillowColor === 'function')
        ? window.updatePillowColor(selectedColor)
        : false;
      if (fastUpdated) {
        currentPillowColor = selectedColor;
        return;
      }
      if (typeof window !== 'undefined' && window.isGeneratingModel) {
        setTimeout(() => {
          if (typeof window.updatePillowColor === 'function') {
            window.updatePillowColor(selectedColor);
          }
        }, 200);
        return;
      }
      generate3D(source, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
    }

    function formatTimer(seconds) {
      const sec = Math.floor(seconds);
      const microsec = Math.floor((seconds - sec) * 100);
      return `${sec}:${microsec.toString().padStart(2, '0')}`;
    }

    function updateTimer() {
      if (uploadStartTime) {
        const elapsed = (performance.now() - uploadStartTime) / 1000;
        document.getElementById('timerDisplay').textContent = formatTimer(elapsed);
      }
    }

    function stopTimer() {
      if (timerInterval) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
    }

    // Convert any image to JPG with max 2500x2500 and optimized quality for speed
    async function compressImage(file) {
      /* ═══ מסלול ההכנה החדש ═══
         כשה-asset נטען, ההכנה עוברת אליו: הוא בוחר JPEG לתמונה אטומה
         ו-PNG רק כשיש שקיפות אמיתית, ומוודא שהתוצאה נכנסת במגבלת
         ה-Lambda. הקוד הישן נשאר מתחת כנפילה־לאחור, ולכן סקשן שלא
         טוען את ה-asset מתנהג בדיוק כמו קודם. */
      if (window.PZImagePrep && typeof window.PZImagePrep.prepare === 'function') {
        try {
          return await window.PZImagePrep.prepare(file, {
            onStatus: function (text) {
              const el = document.getElementById('statusText');
              if (el) el.textContent = text;
            }
          });
        } catch (err) {
          console.warn('הכנת התמונה נכשלה, נופלים למסלול הישן:', err);
        }
      }

      const originalSizeMB = (file.size / 1024 / 1024).toFixed(2);
      const profile = (typeof window !== 'undefined' && window.deviceProfile) ? window.deviceProfile : {};
      const MAX_DIMENSION = profile.isLowPower ? 2000 : 3000; // Smaller on low-power/mobile for speed
      const QUALITY = profile.isLowPower ? 0.85 : 0.9; // Slightly lower quality on low-power for performance
      // const outputType = 'image/jpeg';
      const hasAlpha = file.type === 'image/png';
      const outputType = 'image/png';

      document.getElementById('statusText').textContent = tr('Converting to JPG and resizing...', 'ממיר ומקטין את התמונה...');

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function(e) {
          const img = new Image();
          img.onload = function() {
            let width = img.width;
            let height = img.height;
            const originalWidth = width;
            const originalHeight = height;
            
            // Resize to max 2500x2500 maintaining aspect ratio (like Photoshop)
            if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
              const scale = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
              width = Math.floor(width * scale);
              height = Math.floor(height * scale);
            }
            
            // Create canvas and convert to JPG
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d', { antialias: true, alpha: false });
            ctx.clearRect(0, 0, width, height); // Ensure transparency preserved
            ctx.drawImage(img, 0, 0, width, height);
            
            canvas.toBlob(function(blob) {
              if (!blob) {
                reject(new Error('Failed to convert image'));
                return;
              }
              
              const compressedSizeMB = (blob.size / 1024 / 1024).toFixed(2);
              const fileName = file.name.replace(/\.[^/.]+$/, '') + '.jpg';
              const compressedFile = new File([blob], fileName, {
                type: outputType,
                lastModified: Date.now()
              });
              
              // Show alert with original and compressed sizes
              console.log(`Image converted to JPG\n\nOriginal: ${originalSizeMB}MB (${originalWidth}x${originalHeight})\nCompressed: ${compressedSizeMB}MB (${width}x${height})\nQuality: 75%`);
              
              document.getElementById('statusText').textContent = `${tr('Converted', 'הומר')}: ${originalSizeMB}MB → ${compressedSizeMB}MB`;
              resolve(compressedFile);
            }, outputType, QUALITY);
          };
          
          img.onerror = function() {
            reject(new Error('Failed to load image for compression'));
          };
          
          img.src = e.target.result;
        };
        
        reader.onerror = function() {
          reject(new Error('Failed to read file for compression'));
        };
        
        reader.readAsDataURL(file);
      });
    }
    
    document.getElementById('fileUpload').addEventListener('change', async function(e) {
      const file = e.target.files[0];
      if (!file) return;
      const updateStatus = (text) => {
        if (statusTextEl) statusTextEl.textContent = text;
      };
      const hideProgressBar = () => {
        if (progressContainerEl) progressContainerEl.style.display = 'none';
      };
      const finishLoading = (statusMessage, hideProgress = false) => {
        if (statusMessage) updateStatus(statusMessage);
        stopTimer();
        setLoading(false);
        if (hideProgress) hideProgressBar();
        mainPreviewImage.style.display = "none";
        toggleBtn.style.display = 'block';
        glCanvas.style.display = "block";
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          glCanvas.offsetHeight;
        }
        // ===== iOS WebGL SAFETY (ADD HERE) =====
        if (glCanvas) {
          glCanvas.addEventListener('webglcontextlost', function (e) {
            e.preventDefault();
            console.warn('WebGL context lost on iOS – reloading page');
            location.reload();
          }, false);

          glCanvas.addEventListener('webglcontextrestored', function () {
            console.log('WebGL context restored');
          }, false);
        }
        // ===== FORCE TRANSPARENT BACKGROUND (Fix for iOS white canvas) =====
        const gl = glCanvas.getContext('webgl', {
          alpha: false,                 // 🔥 MUST BE FALSE
          premultipliedAlpha: false,
          preserveDrawingBuffer: true
        });

        // gl.disable(gl.BLEND);
        // if (isIOS) {
        // // iPhone color: #e09df3
        //   gl.clearColor(0.8784, 0.6157, 0.9529, 1.0);
        // } else {
        //   // Default (existing color)
        //   gl.clearColor(1.0, 0.8706, 0.3529, 0.25);
        // }
        // // gl.clearColor(1.0, 0.8706, 0.3529, 0.25);
        // gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

        console.log('WebGL ATTR:', gl.getContextAttributes());
      };

      // Reset state
      uploadedImageUrl = null;
      uploadedImageBase64 = null;
      if (progressContainerEl) progressContainerEl.style.display = 'flex';
      if (progressFillEl) progressFillEl.style.width = '0%';
      if (window.pzProgress) window.pzProgress.start();   // C12
      updateStatus(tr('Processing...', 'מעבד...'));
      setLoading(true, tr('Uploading image...', 'מעלה את התמונה...'));
      
      // Start timer
      uploadStartTime = performance.now();
      timerInterval = setInterval(updateTimer, 10); // Update every 10ms for microsecond precision
      updateTimer();

      let fileToUpload = file;
      
      // Only compress if file size is over 3 MB (3 * 1024 * 1024 = 3145728 bytes)
      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > 3) {
        try {
          fileToUpload = await compressImage(file);
          updateStatus(tr('Uploading...', 'מעלה...'));
        } catch (error) {
          console.error('Compression error:', error);
          updateStatus(tr('Compression failed, uploading original...', 'הדחיסה נכשלה, מעלה את הקובץ המקורי...'));
          // Continue with original file
        }
      } else {
        updateStatus(tr('Uploading...', 'מעלה...'));
      }

      // Create FormData
      const formData = new FormData();
      formData.append('image', fileToUpload);

      // Create XMLHttpRequest for progress tracking
      const xhr = new XMLHttpRequest();

      // Track upload progress
      xhr.upload.addEventListener('progress', function(e) {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100;
          const uploadedMB = (e.loaded / 1024 / 1024).toFixed(2);
          const totalMB = (e.total / 1024 / 1024).toFixed(2);
          // C12: ההעלאה היא רק השליש הראשון של ההמתנה. pzProgress ממפה
          // אותה ל-0-40% ומנהל את שאר הטווח בעצמו.
          if (window.pzProgress) {
            window.pzProgress.uploadFraction(e.loaded / e.total);
            if (e.loaded >= e.total) window.pzProgress.stage(2);
          } else if (progressFillEl) {
            progressFillEl.style.width = percentComplete + '%';
          }
          updateStatus(`${tr('Uploading', 'מעלה')}: ${uploadedMB}MB / ${totalMB}MB (${percentComplete.toFixed(1)}%)`);
        }
      });

      // Handle response
      xhr.addEventListener('load', function() {
        if (window.pzProgress) window.pzProgress.stage(3);   // C12: הרקע הוסר, בונים מודל
        if (xhr.status !== 200) {
          finishLoading(`${tr('Error', 'שגיאה')}: ${xhr.status}`, true);
          return;
        }

        let response = null;
        try {
          response = JSON.parse(xhr.responseText);
        } catch (error) {
          console.error('Error parsing response:', error);
          finishLoading(tr('Error: Invalid response from server', 'שגיאה: תגובה לא תקינה מהשרת'), true);
          return;
        }

        const mimeHint = response.resized_image_data_mime || response.mime_type || response.content_type || undefined;

        // Check if API returned base64 image data - use that directly instead of URL
        let imageSource = null;

        // Set preview images from API response
        if (originalImg && response.original_url) {
          originalImg.src = response.original_url;
        }

        if (processedImg && response.url) {
          processedImg.src = response.url;
        }

        if (response.resized_image_data) {
          const base64Data = normalizeDataUrl(response.resized_image_data, mimeHint || 'image/png');
          uploadedImageBase64 = base64Data;
          uploadedImageUrl = null; // Clear URL since we're using base64
          imageSource = base64Data;

          console.log('Using base64 image data from API response');
          updateStatus(tr('Generating model from resized image...', 'יוצר מודל תלת־ממד מהתמונה...'));
        } else if (response.url) {
          // Fallback to URL if base64 not available
          uploadedImageUrl = response.url;
          uploadedImageBase64 = null; // Clear base64
          imageSource = response.url;

          console.log('Using image URL from API response');
          updateStatus(tr('Generating model...', 'יוצר מודל תלת־ממד...'));
        }

        if (!imageSource) {
          finishLoading(tr('Error: No image returned from server', 'שגיאה: לא התקבלה תמונה מהשרת'), true);
          return;
        }

        // Generate pillow immediately with selected color (default white)
        isUsingUploaded = true;
        currentPillowColor = selectedColor;

        const triggerGeneration = () => {
          generate3D(imageSource, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
          // addHistoryEntry(imageSource, selectedColor);
          addHistoryEntry(
            response.original_url,
            response.url,
            imageSource,
            selectedColor
          );
        };

        // Show final time and clear spinner before heavy work to allow immediate UI update
        const totalTime = (performance.now() - uploadStartTime) / 1000;
        updateStatus(`${tr('Complete! Total time', 'הושלם! זמן כולל')}: ${formatTimer(totalTime)}`);
        if (window.pzProgress) window.pzProgress.done();      // C12
        else if (progressFillEl) progressFillEl.style.width = '100%';
        finishLoading(null, false);

        // Run generation on the next frame so the spinner disappears immediately
        requestAnimationFrame(triggerGeneration);

        // Hide progress after a moment
        setTimeout(() => {
          hideProgressBar();
        }, 1500);
      });

      xhr.addEventListener('error', function() {
        finishLoading(tr('Upload failed', 'ההעלאה נכשלה'), true);
      });

      xhr.addEventListener('abort', function() {
        finishLoading(tr('Upload canceled', 'ההעלאה בוטלה'), true);
      });

      // Send request to PHP proxy
      xhr.open('POST', 'https://gsxutyare2eblggdsiemsmnwnq0dwzui.lambda-url.eu-north-1.on.aws/generatemodel');
      xhr.send(formData);
    });

    // Generate 3D from uploaded image
    function generateFromUploaded(pillowColor) {
      if (!uploadedImageUrl && !uploadedImageBase64) {
        alert(tr('Please upload an image first', 'נא להעלות תמונה תחילה'));
        return;
      }
      if (pillowColor) {
        setSelectedColor(pillowColor);
      }
      isUsingUploaded = true;
      currentPillowColor = selectedColor;
      // Prioritize base64 if available (faster, no network request), otherwise use URL
      const imageUrl = uploadedImageBase64 || uploadedImageUrl;
      generate3D(imageUrl, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
      addHistoryEntry(imageUrl, selectedColor);
    }

    // Update preset button handlers to track state
    function generatePreset(imageUrl, pillowColor) {
      isUsingUploaded = false;
      currentImageUrl = imageUrl;
      if (pillowColor) {
        setSelectedColor(pillowColor);
      }
      generate3D(imageUrl, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
    }

    let initialModelLoaded = false;
    let renderLoopStarted = false;

    function waitForGenerate3D(cb, attempt = 0) {
      if (typeof window.generate3D === 'function') {
        cb();
        return;
      }
      if (attempt > 60) {
        console.warn('generate3D is still not ready after waiting, giving up bootstrap');
        return;
      }
      setTimeout(() => waitForGenerate3D(cb, attempt + 1), 100);
    }

    function safeGenerate3D(...args) {
      if (typeof window.generate3D !== 'function') {
        console.warn('generate3D not ready, skipping call');
        return false;
      }
      window.generate3D(...args);
      return true;
    }

    function startRenderLoop() {
      if (renderLoopStarted) return;
      renderLoopStarted = true;
      requestAnimationFrame(animate);
    }

    function bootstrapInitialModel() {
      if (initialModelLoaded) return;
      initialModelLoaded = true;

      const history = readHistory();
      const latest = history && history.length ? history[0] : null;

      if (latest && latest.src) {
        try {
          setSelectedColor(latest.color || '#ffffff');
          uploadedImageBase64 = latest.src;
          uploadedImageUrl = null;
          isUsingUploaded = true;
          currentPillowColor = selectedColor;
          const progress = document.getElementById('progressContainer');
          if (progress) progress.style.display = 'none';
          if (safeGenerate3D(latest.src, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent)) {
            return;
          }
          // If we failed to call generate3D, fall through to default
          return;
        } catch (err) {
          console.warn('Failed to load last upload from history, falling back to default', err);
        }
      }

      isUsingUploaded = false;
      currentImageUrl = currentImageUrl || window.bgTextureUrl;
      safeGenerate3D(currentImageUrl, zoomEnabled, 1, 6, [0, 0, 1], 128, 10, true, selectedColor, '#8b5dbe', paddingPercent, 0, centervolumePercent, edgevolumePercent, 0.05, 3, 2, magnetPower, labelRatio, labelHeightPercent);
    }

    renderColorSwatches();
    renderHistory();

    const kickOff = () => {
      waitForGenerate3D(() => {
        bootstrapInitialModel();
        startRenderLoop();
      });
    };

    setTimeout(kickOff, 500);
    ['touchstart', 'mousedown'].forEach(evt => {
      window.addEventListener(evt, kickOff, { once: true, passive: true });
    });